import React from 'react'
import { useState } from 'react'
import { Link, useOutletContext } from 'react-router-dom'
function GroupJoiningCard({data, type}) {
    const [status, setStatus] = useState(false);
    const { user, token } = useOutletContext();
    const [message, setMessage] = useState("");
    const [status2, setStatus2] = useState(false);

    const AcceptGroupRequest = () => {
        fetch('/api/accept-group-request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
             Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: data.id,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
      
            setStatus(2);
          })
          .catch((error) => {
            console.log(error);
          });
    }
    const DeleteGroupRequest = () => {
        fetch('/api/delete-group-request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
             Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: data.id,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            
            setStatus(2);
          })
          .catch((error) => {
            console.log(error);
          });
    }
if (type=="request") {   
    return (
        <div className="col-md-4 col-sm-4 col-6 pe-2 ps-2 my-2">
              <div className="card d-flex flex-column border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                <div className="card-body d-flex flex-column align-items-center w-100 ps-3 pe-3 pb-4 text-center">
                  <figure className="avatar-2 ms-auto me-auto mb-0 position-relative w65 z-index-1">
                    <img src={data?.user.personal_details?.profile_picture} alt="image" className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} /></figure>
                  <div className="clearfix" />
                  <h4 className="fw-700 font-xsss mt-3 mb-1">{data?.user.name}</h4>
                  <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{data?.user.role}</p>
                  {}
                  {
                    status ? <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{message}</p> : <div>
                    <button className="p-2 lh-20 w100 bg-primary-gradiant my-2 me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red btn" onClick={AcceptGroupRequest}>Accept</button>
                    <button className="p-2 lh-20 w100 bg-red-gradiant my-2 me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red btn" onClick={DeleteGroupRequest}>Delete</button>
                    </div>
                  }
                </div>
              </div>
            </div> 
  )
}else {
    return (
         <div className="col-md-4 col-sm-4 col-6 pe-2 ps-2 my-2">
              <div className="card d-flex flex-column border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                <div className="card-body d-flex flex-column align-items-center w-100 ps-3 pe-3 pb-4 text-center">
                  <figure className="avatar-2 ms-auto me-auto mb-0 position-relative w65 z-index-1">
                    <img src={data?.user.personal_details?.profile_picture} alt="image" className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} /></figure>
                  <div className="clearfix" />
                  <h4 className="fw-700 font-xsss mt-3 mb-1">{data?.user.name}</h4>
                  <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{data?.user.role}</p>
                 
                </div>
              </div>
            </div> 
    )
}
}

export default GroupJoiningCard